import { Flow_0_0_2 } from '@flexus/core';

export const BET_4: Flow_0_0_2 = {
	id: '4',
	name: 'invalid_work_in_progress',
	itemType: 'flow',
	header: {
		title: 'Invalid Claim',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'Placeholder'
		},
		viewRoles: {
			0: 'Placeholder'
		}
	},
	startNode: '',
	nodes: {}
};
